"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63505],{

/***/ 230290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ RelatedPromotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(857387);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(853675);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(243290);






const renderDetailPromotionContent = (benefitType, data)=>{
    switch(benefitType){
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .BENEFIT_TYPE.discount */ .s.discount:
            const { percent , maxAmount , flat  } = data;
            return percent !== null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("{{percent}}% tối đa", {
                        percent: percent
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledCurrency */ .DY, {
                        value: maxAmount || 0
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledCurrency */ .DY, {
                value: flat || 0
            });
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .BENEFIT_TYPE.gifts */ .s.gifts:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                children: data.map((param)=>{
                    let { name , quantity  } = param;
                    return "".concat(quantity, " ").concat(name);
                }).join(", ")
            });
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .BENEFIT_TYPE.voucher */ .s.voucher:
            const { quantity , name  } = data;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                children: name ? "".concat(quantity, " ").concat(name) : "Voucher"
            });
        default:
            return null;
    }
};
const RelatedPromotion = (param)=>{
    let { promotion  } = param;
    const { isDefault , benefit , condition , promotionType , type  } = promotion;
    const { data , type: benefitType  } = benefit;
    // Magento
    if (promotionType === _types__WEBPACK_IMPORTED_MODULE_2__/* .PROMOTION_TYPE.magento */ .j.magento) {
        const { coupon , benefit: benefit1 , extraCondition , url  } = data;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Nhập m\xe3"),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: coupon
                }),
                " ",
                (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("giảm th\xeam"),
                " ",
                benefit1.discountPercent,
                (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("% tối đa"),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledCurrency */ .DY, {
                    value: benefit1.maxDiscount
                }),
                extraCondition,
                " ",
                (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("khi thanh to\xe1n qua VNPAY-QR."),
                url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                    href: url,
                    target: "blank",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Xem chi tiết")
                })
            ]
        });
    }
    // Custom magento
    if (promotionType === _types__WEBPACK_IMPORTED_MODULE_2__/* .PROMOTION_TYPE.customMagento */ .j.customMagento) {
        const { text , url: customUrl  } = data;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: text
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                    href: customUrl,
                    target: "blank",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Xem chi tiết")
                })
            ]
        });
    }
    const isDiscount = benefitType === "discount";
    const renderPrefixText = ()=>{
        if (isDefault || type !== "coupon") {
            return isDiscount ? (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Giảm") : (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Tặng");
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Nhập m\xe3"),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: (condition === null || condition === void 0 ? void 0 : condition.coupon) || ""
                }),
                " ",
                isDiscount ? (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("giảm") : (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("tặng")
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        children: [
            renderPrefixText(),
            " ",
            renderDetailPromotionContent(benefitType || "", data),
            " ",
            (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("cho đơn h\xe0ng"),
            " ",
            !!(condition === null || condition === void 0 ? void 0 : condition.orderValueMin) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("từ"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Currency */ .F, {
                        value: condition.orderValueMin
                    })
                ]
            }),
            !!(condition === null || condition === void 0 ? void 0 : condition.orderValueMax) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    " ",
                    (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("đến"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Currency */ .F, {
                        value: condition.orderValueMax
                    })
                ]
            }),
            " ",
            !!(condition === null || condition === void 0 ? void 0 : condition.hasProductCondition) && (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("c\xf3 sản phẩm n\xe0y"),
            isDefault && (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("sites.shop-front.components.RelatedPromotion.0")
        ]
    });
};


/***/ }),

/***/ 590498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ RelatedPromotionV2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(853675);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(243290);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);





const renderDetailPromotionContent = (benefit, isCoupon)=>{
    const { gifts , voucher , discount  } = benefit;
    const renderAndText = " " + (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("v\xe0") + " ";
    const renderDiscount = ()=>{
        if (discount && Object.keys(discount).length) {
            const { percent , maxAmount , flat  } = discount;
            return percent !== null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("{{percent}}% ", {
                        percent: percent
                    }),
                    !!maxAmount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("tối đa"),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledCurrency */ .DY, {
                                value: maxAmount
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledCurrency */ .DY, {
                value: flat || 0
            });
        }
    };
    const renderGifts = ()=>{
        if (gifts && gifts.length) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: gifts.map((param, index)=>/*#__PURE__*/ {
                    let { name , quantity , imageUrl  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: " ".concat(quantity, " ").concat(name)
                            }),
                            !!imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                style: {
                                    objectFit: "contain",
                                    height: "20px",
                                    width: "20px"
                                },
                                src: imageUrl,
                                alt: name
                            }),
                            index !== gifts.length - 1 && ", "
                        ]
                    }, "".concat(index).concat(name));
                })
            });
        }
        return null;
    };
    const renderVoucher = ()=>{
        if (voucher && Object.keys(voucher).length) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                children: voucher.name ? "".concat(voucher.quantity, " ").concat(voucher.name) : "Voucher"
            });
        }
        return null;
    };
    const content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            renderDiscount() && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("giảm") + " ",
            renderDiscount(),
            renderDiscount() && renderGifts() && renderAndText,
            renderGifts() && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("tặng"),
            renderGifts(),
            renderDiscount() && renderVoucher() && !renderGifts() && renderAndText,
            renderGifts() && renderVoucher() && ", ",
            renderVoucher() && !renderGifts() && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("tặng"),
            " ",
            renderVoucher()
        ]
    });
    if (!isCoupon) {
        let spinner = true;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(content, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(content.props.children, (element)=>{
                if (typeof element === "string" && spinner) {
                    if (!!element) {
                        spinner = false;
                        return element.charAt(0).toUpperCase() + element.slice(1);
                    }
                }
                return element;
            })
        });
    }
    return content;
};
const RelatedPromotionV2 = (param)=>{
    let { validPromotion  } = param;
    const { isDefault , benefit , condition , type , description  } = validPromotion;
    const isCoupon = !isDefault && type === "coupon";
    const isGiftCode = !isDefault && type === "gift-code";
    // Custom magento from PPM
    if (type === "qr") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: description || ""
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        children: [
            (isCoupon || isGiftCode) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Nhập m\xe3"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        children: (condition === null || condition === void 0 ? void 0 : condition.coupon) || ""
                    }),
                    " "
                ]
            }),
            renderDetailPromotionContent(benefit, isCoupon || isGiftCode),
            " ",
            (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("cho đơn h\xe0ng"),
            " ",
            !!(condition === null || condition === void 0 ? void 0 : condition.orderValueMin) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("từ"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Currency */ .F, {
                        value: condition.orderValueMin
                    })
                ]
            }),
            !!(condition === null || condition === void 0 ? void 0 : condition.orderValueMax) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    " ",
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("đến"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Currency */ .F, {
                        value: condition.orderValueMax
                    })
                ]
            }),
            " ",
            !!(condition === null || condition === void 0 ? void 0 : condition.hasProductCondition) && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("c\xf3 sản phẩm n\xe0y"),
            isDefault && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("sites.shop-front.components.RelatedPromotion.0")
        ]
    });
};


/***/ }),

/***/ 170604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ useDetailPromotion; },
  "T": function() { return /* binding */ useGetProductsCombos; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(859676);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./services/clients/api.ts
var api = __webpack_require__(44844);
// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(847143);
;// CONCATENATED MODULE: ./services/ppm.ts


api/* ppmApi.addInterceptor */.Gp.addInterceptor(interceptor_es/* accessTokenInterceptor */.E);
class PpmService {
    async getRelatedPromotion(param) {
        let { type , sku , terminalId , terminal , language  } = param;
        var ref, ref1;
        const res = await api/* ppmApi.get */.Gp.get("/promotions", {
            params: {
                type,
                skus: sku,
                terminalId,
                terminal
            },
            headers: {
                "Accept-Language": language || "*"
            }
        });
        return (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1.promotions) || [];
    }
    async getPrivatePromotion(param) {
        let { type , sku , terminalId , terminal , language  } = param;
        var ref, ref1;
        const res = await api/* ppmApi.get */.Gp.get("/private-promotions", {
            params: {
                type,
                skus: sku,
                terminalId,
                terminal
            },
            headers: {
                "Accept-Language": language || "*"
            }
        });
        return (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1.promotions) || [];
    }
    async getProductsCombos(param) {
        let { skus , terminalId , language  } = param;
        const res = await api/* ppmApi.post */.Gp.post("/products/combos", {
            skus,
            terminalId
        }, {
            headers: {
                "Accept-Language": language || "*"
            }
        });
        return res.data;
    }
}
const ppmService = new PpmService();

// EXTERNAL MODULE: ./types/promotions.ts
var promotions = __webpack_require__(857387);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var index_es = __webpack_require__(420577);
;// CONCATENATED MODULE: ./hooks/useDetailPromotion.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








const transformPromotionV2 = (promotion, productSku)=>{
    const { condition  } = promotion;
    const basePromotion = _objectSpreadProps(_objectSpread({}, promotion), {
        condition: _objectSpreadProps(_objectSpread({}, condition), {
            hasProductCondition: !!condition.skus.filter((param)=>{
                let { sku  } = param;
                return sku === productSku;
            }).length
        })
    });
    return [
        basePromotion
    ];
};
// Flat benefit
const transformPromotion = (promotion, productSku)=>{
    const { benefit , condition  } = promotion;
    const { gifts , voucher , discount  } = benefit;
    const basePromotion = _objectSpreadProps(_objectSpread({}, promotion), {
        condition: _objectSpreadProps(_objectSpread({}, condition), {
            hasProductCondition: !!condition.skus.filter((param)=>{
                let { sku  } = param;
                return sku === productSku;
            }).length
        })
    });
    const giftData = gifts && gifts.length ? [
        _objectSpreadProps(_objectSpread({}, basePromotion), {
            benefit: {
                type: promotions/* BENEFIT_TYPE.gifts */.s.gifts,
                data: gifts
            }
        }), 
    ] : [];
    const voucherData = voucher && Object.keys(voucher).length ? [
        _objectSpreadProps(_objectSpread({}, basePromotion), {
            benefit: {
                type: promotions/* BENEFIT_TYPE.voucher */.s.voucher,
                data: voucher
            }
        }), 
    ] : [];
    const discountData = discount && Object.keys(discount).length ? [
        _objectSpreadProps(_objectSpread({}, basePromotion), {
            benefit: {
                type: promotions/* BENEFIT_TYPE.discount */.s.discount,
                data: discount
            }
        }), 
    ] : [];
    return [
        ...discountData,
        ...giftData,
        ...voucherData
    ];
};
/** Valid promotions:
 * public
 * applied for product sku or all skus
 * applied for sellerId of product or all sellers
 * not expired
 */ const filterValidPromotions = (promotions, param)=>{
    let { seller , sku: productSku  } = param;
    return promotions.filter((param)=>{
        let { applySellerIds , startedAt , endedAt , condition  } = param;
        const isValidSku = !condition.skus.length || condition.skus.filter((param)=>{
            let { sku  } = param;
            return sku === productSku;
        }).length;
        const isValidSellerId = !applySellerIds.length || seller && applySellerIds.includes(seller.id);
        const isValidDate = !!startedAt && !!endedAt && (0,helpers/* checkExpiryDate */.N6)(new Date(startedAt).toISOString(), new Date(endedAt).toISOString());
        return isValidSku && isValidSellerId && isValidDate;
    });
};
const getShowedPromotions = (promotions, price)=>{
    return promotions.filter((param)=>{
        let { condition  } = param;
        if (!condition) return false;
        const { hasProductCondition , orderValueMin  } = condition;
        return hasProductCondition || !hasProductCondition && (orderValueMin === null || orderValueMin === undefined || price >= orderValueMin);
    });
};
const isBenefitEmpty = (benefit)=>{
    return (!benefit.gifts || !benefit.gifts.length) && (!benefit.money || !benefit.money.length) && (!benefit.items || !benefit.items.length) && !benefit.voucher && !benefit.discount;
};
const getShowedPromotionsV2 = (promotions, price)=>{
    return promotions.filter((param)=>{
        let { condition , isDefault , benefit  } = param;
        if (!condition) return false;
        // Check valid promotion according to task https://jira.teko.vn/browse/UX4BUYER-7825
        if (!isDefault && !condition.coupon && isBenefitEmpty(benefit)) return false;
        const { hasProductCondition , orderValueMin  } = condition;
        return hasProductCondition || !hasProductCondition && (orderValueMin === null || orderValueMin === undefined || price >= orderValueMin);
    });
};
const useDetailPromotion = (product, price)=>{
    const { 0: allPromotions , 1: setAllPromotions  } = (0,react.useState)([]);
    const { 0: validPromotions , 1: setValidPromotions  } = (0,react.useState)([]);
    const { 0: promotions , 1: setPromotions  } = (0,react.useState)([]);
    const { user , loading  } = (0,context_es/* useAuth */.aC)();
    const { currentLanguage , terminalId , terminal , useTerminalId , displayPublicCouponInRelatedPromotions ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    (0,react.useEffect)(()=>{
        let isSubscribed = true;
        if (product && !loading) {
            const { sku  } = product;
            if (!sku) {
                index_es/* logger.error */.k.error("Exception: Calling PPM API get promotions with no product SKU, product info: ".concat(JSON.stringify(product || {})));
                return;
            }
            const getPromotionPromise = user ? ppmService.getPrivatePromotion : ppmService.getRelatedPromotion;
            getPromotionPromise(_objectSpreadProps(_objectSpread({
                type: displayPublicCouponInRelatedPromotions ? "coupon,order,qr,gift-code" : "coupon,order,qr",
                sku: sku
            }, flags.epic_ecom_284 || useTerminalId ? {
                terminalId
            } : {
                terminal
            }), {
                language: currentLanguage
            })).then((promotions)=>{
                if (!isSubscribed) return;
                const validPromotions = filterValidPromotions(promotions, product);
                const formattedPromotions = [];
                const formattedPromotionsV2 = [];
                for(const index in validPromotions){
                    //Epic: https://jira.teko.vn/browse/OMNI-552
                    if (validPromotions[index].type === "qr") {
                        formattedPromotions.push(_objectSpread({}, validPromotions[index]));
                        formattedPromotionsV2.push(_objectSpread({}, validPromotions[index]));
                    } else {
                        var ref;
                        formattedPromotions.push(...transformPromotion(validPromotions[index], sku));
                        if (!validPromotions[index].isDefault && !((ref = validPromotions[index].condition) === null || ref === void 0 ? void 0 : ref.coupon) && isBenefitEmpty(validPromotions[index].benefit)) {
                            continue;
                        }
                        formattedPromotionsV2.push(...transformPromotionV2(validPromotions[index], sku));
                    }
                }
                setAllPromotions(formattedPromotions);
                setValidPromotions(formattedPromotionsV2);
            });
        }
        return ()=>{
            isSubscribed = false;
        };
    }, [
        user,
        loading
    ]);
    (0,react.useEffect)(()=>{
        if (price && allPromotions.length) {
            setPromotions(getShowedPromotions(allPromotions, price));
            setValidPromotions(getShowedPromotionsV2(validPromotions, price));
        }
    }, [
        price,
        JSON.stringify(allPromotions)
    ]);
    return {
        promotions,
        validPromotions
    };
};
const useGetProductsCombos = function() {
    let skus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ref;
    const { currentLanguage , terminalId , epicOmni1286  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { data , error  } = (0,index_esm/* default */.ZP)(epicOmni1286 && !!skus.length ? [
        "combos",
        skus.join()
    ] : null, async (_)=>{
        return await ppmService.getProductsCombos({
            skus,
            terminalId,
            language: currentLanguage
        });
    }, {
        revalidateOnFocus: false
    });
    return {
        result: {
            products: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.products) || []
        },
        isLoading: !error && !data,
        isError: error
    };
};


/***/ }),

/***/ 463505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductRelatedPromotions": function() { return /* binding */ ProductRelatedPromotions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(534924);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(170604);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(243290);
/* harmony import */ var components_RelatedPromotion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(230290);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(329944);
/* harmony import */ var _teko_types_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(184019);
/* harmony import */ var components_RelatedPromotionV2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(590498);










const ProductRelatedPromotions = (param)=>{
    let { extraPromotions  } = param;
    const { product , price  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useProductDetailState */ .W)();
    const { validPromotions  } = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useDetailPromotion */ .n)(product, price === null || price === void 0 ? void 0 : price.finalPrice);
    const showAllPromotion = [
        ...validPromotions,
        ...extraPromotions || []
    ];
    return !!(showAllPromotion === null || showAllPromotion === void 0 ? void 0 : showAllPromotion.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Divider */ .i, {
                dividerStyle: _teko_types_shared__WEBPACK_IMPORTED_MODULE_2__/* .DividerStyleEnum.dashed */ .fd.dashed,
                margin: [
                    "s12",
                    "s0"
                ],
                color: "divider"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_6__/* .RelatedPromotions */ .g$, {
                className: "BOXKHUYENMAILIENQUAN",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_6__/* .Title */ .Dx, {
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Khuyến m\xe3i li\xean quan")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        children: [
                            validPromotions.map((promotion, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RelatedPromotionV2__WEBPACK_IMPORTED_MODULE_8__/* .RelatedPromotionV2 */ .u, {
                                        validPromotion: promotion
                                    })
                                }, index)),
                            extraPromotions === null || extraPromotions === void 0 ? void 0 : extraPromotions.map((promotion, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RelatedPromotion__WEBPACK_IMPORTED_MODULE_9__/* .RelatedPromotion */ .e, {
                                        promotion: promotion
                                    })
                                }, index))
                        ]
                    })
                ]
            })
        ]
    }) : null;
};


/***/ }),

/***/ 857387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ PROMOTION_TYPE; },
/* harmony export */   "s": function() { return /* binding */ BENEFIT_TYPE; }
/* harmony export */ });
var BENEFIT_TYPE;
(function(BENEFIT_TYPE) {
    BENEFIT_TYPE["voucher"] = "voucher";
    BENEFIT_TYPE["gifts"] = "gifts";
    BENEFIT_TYPE["discount"] = "discount";
})(BENEFIT_TYPE || (BENEFIT_TYPE = {}));
var PROMOTION_TYPE;
(function(PROMOTION_TYPE) {
    PROMOTION_TYPE["magento"] = "magento";
    PROMOTION_TYPE["customMagento"] = "customMagento";
})(PROMOTION_TYPE || (PROMOTION_TYPE = {}));


/***/ })

}]);